<template>
    <section class="decoration-edit" v-loading="loading">
        <section class="l">
            <ul @dragstart="dragStart" @dragend="dragEnd">
                <template v-for="(item, key, index) in typeList">
                    <li v-if="!item.hide" draggable :data-type="key" :key="index + 1">
                        <div v-html="item.icon"></div>
                        <p>{{ item.text }}</p>
                    </li>
                </template>
            </ul>
        </section>
        <section class="c">
            <div class="mobile-device">
                <div class="top-nav" @click="selectItem(0)" :class="{ 'selected': curIndex === 0 }">
                    <img src="./../assets/images/topNavBlack.png">
                    <span class="tit">查询结果</span>
                </div>
                <PageView v-if="viewConfigs && viewConfigs.length" @drag-over="dragOver" v-model="viewConfigs[0].data"
                    :currentStyle="viewConfigs[0].style" class="page-container">
                    <vuedraggable v-model="viewConfigs" draggable=".item">
                        <template v-for="(item, index) in viewConfigs">
                            <div v-if="index > 0" :data-index="index" :key="index" class="item"
                                @click="selectItem(index)">
                                <template v-if="item && item.status == 2">
                                    <div class="wait"> {{ item.type }} </div>
                                </template>
                                <template v-else>
                                    <component :is="typeList[item.type]['viewCom']" v-model="item.data"
                                        :currentStyle="item.style" :class="{ 'selected': curIndex === index }"
                                        :style="{ padding: item.type === 'banner' ? '0' : '0 var(--padding-x)' }">
                                    </component>
                                </template>
                                <i @click="deleteItem($event, index)" class="el-icon-error"></i>
                            </div>
                        </template>
                    </vuedraggable>
                </PageView>
            </div>
            <div class="submit-btn">
                <el-button type="primary" size="medium" round @click="submit">提交页面</el-button>
            </div>
        </section>
        <section class="r">
            <template v-if="curConfig">
                <component :is="typeList[curConfig.type]['editCom']" v-model="curConfig.data" :name="curConfig.text"
                    :type="curConfig.type" :styleList="curConfig.styleList" :currentStyle.sync="curConfig.style" />
            </template>
        </section>
    </section>
</template>

<script>
import { customPagesave, customPage } from "@/api/qrcode";
import vuedraggable from 'vuedraggable'
import PageEdit from '../components/Edit/PageEdit'
import ImageEdit from '../components/Edit/ImageEdit'
import TextEdit from '../components/Edit/TextEdit'
import ImageTextEdit from '../components/Edit/ImageTextEdit'
import ProductEdit from '../components/Edit/ProductEdit'
import VerifyEdit from '../components/Edit/VerifyEdit'
import SpacingEdit from '../components/Edit/SpacingEdit'
import DividerEdit from '../components/Edit/DividerEdit'
import PageView from '../components/View/PageView'
import BannerView from '../components/View/BannerView'
import ImageView from '../components/View/ImageView'
import TextView from '../components/View/TextView'
import ImageTextView from '../components/View/ImageTextView'
import ProductView from '../components/View/ProductView'
import VerifyView from '../components/View/VerifyView'
import SpacingView from '../components/View/SpacingView'
import DividerView from '../components/View/DividerView'

export default {
    components: {
        vuedraggable,
        PageEdit,
        ImageEdit,
        TextEdit,
        ProductEdit,
        VerifyEdit,
        SpacingEdit,
        DividerEdit,
        PageView,
        BannerView,
        ImageView,
        TextView,
        ImageTextView,
        ProductView,
        VerifyView,
        SpacingView,
        DividerView,
    },
    data() {
        return {
            templateId: null,
            loading: false,
            /**
             * 用户可添加的组件类型列表，page组件需隐藏（页面自带，这里用来定义page组件信息）
             * 组件需设置 text(名称)、icon(图标)、viewCom(视图组件)、editCom(编辑组件)、styleList(样式列表)、defaultStyle(默认样式)、defaultData(默认数据)
             * defaultData数据格式：
             * {
             *     ky1: value1,  // 样式字段，如字体、颜色等；其它字段
             *     data: []   // 组件数据，如图片、文本等，无数据可不设置
             * }
             */
            typeList: {
                page: {
                    text: '页面',
                    icon: '',
                    viewCom: PageView,
                    editCom: PageEdit,
                    styleList: [
                        {
                            name: '默认布局',
                            value: 'style1'
                        }
                    ],
                    defaultStyle: 'style1',
                    defaultData: {
                        backgroundColor: '',
                        backgroundImage: '',
                        paddingX: 20,
                        remark: '',
                    },
                    hide: true
                },
                banner: {
                    text: '轮播图',
                    icon: '<svg t="1776146016048" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="19687" width="40" height="40"><path d="M412.8 448c38.4 0 76.8-22.4 89.6-57.6 16-35.2 6.4-76.8-19.2-105.6s-70.4-35.2-105.6-19.2c-35.2 12.8-57.6 51.2-57.6 89.6 0 51.2 41.6 92.8 92.8 92.8z m-19.2-118.4c6.4-6.4 12.8-9.6 22.4-9.6 16 0 32 12.8 32 28.8s-12.8 32-28.8 35.2c-16 0-32-12.8-35.2-28.8 0-9.6 3.2-19.2 9.6-25.6z" fill="#999999" p-id="19688"></path><path d="M896 224h-32v-64c0-35.2-28.8-64-64-64H224c-35.2 0-64 28.8-64 64v64h-32c-35.2 0-64 28.8-64 64v448c0 35.2 28.8 64 64 64h32v64c0 35.2 28.8 64 64 64h576c35.2 0 64-28.8 64-64v-64h32c35.2 0 64-28.8 64-64V288c0-35.2-28.8-64-64-64zM160 736c-19.2 0-32-12.8-32-32V320c0-19.2 12.8-32 32-32v448z m640 96c0 19.2-12.8 32-32 32H256c-16 0-32-12.8-32-32V192c0-19.2 12.8-32 32-32h512c16 0 32 12.8 32 32v640z m96-128c0 19.2-12.8 32-32 32V288c16 0 32 12.8 32 32v384z" fill="#999999" p-id="19689"></path><path d="M684.8 464L550.4 598.4l-67.2-67.2c-6.4-6.4-12.8-9.6-22.4-9.6-9.6 0-16 3.2-22.4 9.6l-160 160c-12.8 12.8-12.8 32 0 44.8 12.8 12.8 32 12.8 44.8 0l134.4-134.4 67.2 67.2c6.4 6.4 12.8 9.6 22.4 9.6 9.6 0 16-3.2 22.4-9.6l160-160c12.8-12.8 12.8-32 0-44.8-9.6-12.8-32-12.8-44.8 0z" fill="#999999" p-id="19690"></path></svg>',
                    viewCom: BannerView,
                    editCom: ImageEdit,
                    styleList: [
                        {
                            name: '默认布局',
                            value: 'style1'
                        }
                    ],
                    defaultStyle: 'style1',
                    defaultData: {
                        data: []
                    }
                },
                image: {
                    text: '图片',
                    icon: '<svg t="1776146072945" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="24553" width="40" height="40"><path d="M 890 63.91 H 134 a 70 70 0 0 0 -70 70 v 756 a 70 70 0 0 0 70 70 h 756 a 70 70 0 0 0 70 -70 v -756 a 70 70 0 0 0 -70 -70 Z M 144.25 815.56 l 150.09 -150.48 L 456.2 826.53 a 40.79 40.79 0 0 0 57.12 0 l 87.94 -88.3 l 142 141.71 H 214 a 70 70 0 0 1 -69.75 -64.38 Z M 880 809.91 a 70 70 0 0 1 -33.94 60 L 629.43 653.72 a 40.1 40.1 0 0 0 -56.55 0 l -88.23 88.6 l -162.22 -161.79 a 40 40 0 0 0 -56.43 0 c -0.6 0.6 -1.17 1.21 -1.72 1.84 L 144 703 V 214 a 70 70 0 0 1 70 -70 h 596 a 70 70 0 0 1 70 70 Z" fill="#999999" p-id="24554"></path><path d="M 648.43 223.91 a 151 151 0 1 0 151 151 a 151 151 0 0 0 -151 -151 Z m 0 222 a 71 71 0 1 1 71 -71 a 71 71 0 0 1 -71 71 Z" fill="#999999" p-id="24555"></path></svg>',
                    viewCom: ImageView,
                    editCom: ImageEdit,
                    styleList: [
                        {
                            name: '每行一张图片，居中显示',
                            value: 'style1'
                        },
                        {
                            name: '每行一张图片，居左显示',
                            value: 'style2'
                        },
                        {
                            name: '每行一张图片，居右显示',
                            value: 'style3'
                        },
                        {
                            name: '每行多张图片，均匀分布',
                            value: 'style4'
                        },
                    ],
                    defaultStyle: 'style1',
                    defaultData: {
                        imageWidth: 100,
                        data: []
                    }
                },
                text: {
                    text: '文本',
                    icon: '<svg t="1776145888600" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16351" width="40" height="40"><path d="M921.6 256L704 38.4C678.4 12.8 646.4 0 614.4 0H192C121.6 0 64 57.6 64 128v768c0 70.4 57.6 128 128 128h640c70.4 0 128-57.6 128-128V345.6c0-32-12.8-64-38.4-89.6zM640 70.4c6.4 0 12.8 6.4 19.2 12.8l217.6 217.6c6.4 6.4 6.4 12.8 12.8 19.2H640V70.4zM896 896c0 38.4-25.6 64-64 64H192c-38.4 0-64-25.6-64-64V128c0-38.4 25.6-64 64-64h384v288c0 19.2 12.8 32 32 32H896v512z" fill="#999999" p-id="16352"></path><path d="M256 544c0 19.2 12.8 32 32 32h448c19.2 0 32-12.8 32-32s-12.8-32-32-32h-448c-19.2 0-32 12.8-32 32zM736 704h-448c-19.2 0-32 12.8-32 32s12.8 32 32 32h448c19.2 0 32-12.8 32-32s-12.8-32-32-32zM288 384h128c19.2 0 32-12.8 32-32S435.2 320 416 320h-128c-19.2 0-32 12.8-32 32s12.8 32 32 32z" fill="#999999" p-id="16353"></path></svg>',
                    viewCom: TextView,
                    editCom: TextEdit,
                    styleList: [
                        {
                            name: '文字居中显示',
                            value: 'style1'
                        },
                        {
                            name: '文字开头顶格显示',
                            value: 'style2'
                        },
                        {
                            name: '文字开头空两个字符（段落格式）',
                            value: 'style3'
                        },
                    ],
                    defaultStyle: 'style1',
                    defaultData: {
                        font: {
                            fontFamily: 'Microsoft YaHei',
                            fontSize: '16px',
                            fontWeight: '400',
                            color: '#333333',
                            lineHeight: '1.6'
                        },
                        data: []
                    }
                },
                imageText: {
                    text: '图文',
                    icon: '<svg t="1776145963457" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="18857" width="40" height="40"><path d="M978.11 46.73C948.47 16.59 909.13 0 867.3 0H156.76C114.93 0 75.59 16.59 45.95 46.73 16.76 76.45 0 117.58 0 159.62v704.72c0 42.65 16.32 82.75 45.95 112.93 29.66 30.14 69 46.73 110.81 46.73h710.55c41.81 0 81.15-16.59 110.81-46.73 29.62-30.18 45.93-70.28 45.93-112.93V159.62c-0.01-42.04-16.75-83.21-45.94-112.89zM69.17 159.62c0-49.08 39.3-89.05 87.59-89.05h710.55c48.29 0 87.59 39.98 87.59 89.05v704.72c0 49.12-39.3 89.09-87.59 89.09H156.76c-48.29 0-87.59-39.98-87.59-89.09V159.62z" fill="#999999" p-id="18858"></path><path d="M228.64 858.16h224.69c19.06 0 34.58-15.81 34.58-35.28s-15.52-35.28-34.58-35.28H228.64c-19.06 0-34.58 15.81-34.58 35.28s15.52 35.28 34.58 35.28zM228.64 709.99h564.33c19.06 0 34.58-15.81 34.58-35.28s-15.52-35.28-34.58-35.28H228.64c-19.06 0-34.58 15.81-34.58 35.28s15.52 35.28 34.58 35.28zM273.95 539.63h473.69c44.07 0 79.91-36.11 79.91-80.53V268.97c0-44.42-35.84-80.53-79.91-80.53H273.95c-44.05 0-79.89 36.11-79.89 80.53V459.1c0 44.42 35.84 80.53 79.89 80.53zM757.42 459.1c0 5.48-4.38 9.92-9.78 9.92H273.95c-5.37 0-9.76-4.45-9.76-9.92V268.97c0-5.48 4.38-9.92 9.76-9.92h473.69c5.39 0 9.78 4.45 9.78 9.92V459.1z" fill="#999999" p-id="18859"></path></svg>',
                    viewCom: ImageTextView,
                    editCom: ImageTextEdit,
                    styleList: [
                        {
                            name: '图文左右分布，每行一项',
                            value: 'style1'
                        },
                        {
                            name: '图文上下分布，每行一项，居中显示',
                            value: 'style2'
                        },
                        {
                            name: '图文上下分布，每行多项，均匀分布',
                            value: 'style3'
                        },
                    ],
                    defaultStyle: 'style1',
                    defaultData: {
                        font: {
                            fontFamily: 'Microsoft YaHei',
                            fontSize: '16px',
                            fontWeight: 400,
                            color: '#333333',
                            lineHeight: '1.6'
                        },
                        imageWidth: 50,
                        order: 'asc',
                        data: []
                    }
                },
                verify: {
                    text: '防伪标识',
                    icon: '<svg t="1776146241820" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="30795" width="40" height="40"><path d="M522.943 66.907l359.5 130a32 32 0 0 1 20.717 25.039c27.992 175.014 14.107 328.103-42.214 458.724-57.71 133.845-171.764 226.658-339.532 277.933a32 32 0 0 1-19.056-0.11C333.785 904.85 219.865 812.144 163.177 680.67c-55.305-128.266-69.18-281.243-42.252-458.477a32 32 0 0 1 20.755-25.286l359.5-130a32 32 0 0 1 21.763 0z m-10.882 64.12L181.497 250.564l-0.144 1.054C160.268 407.5 173.48 540.775 220.452 651.83l1.494 3.5c47.345 109.804 141.99 188.962 286.288 237.738l4.013 1.343 3.887-1.253c141.72-46.209 235.79-124.184 284.534-234.374l1.509-3.454c49.134-113.956 62.879-248.378 40.74-403.746l-0.14-0.966-330.716-119.591zM491 266c109.905 0 199 89.095 199 199 0 46.16-15.716 88.65-42.09 122.408l-0.11 0.137 75.327 75.328c12.372 12.371 12.496 32.353 0.372 44.877l-0.372 0.377c-12.496 12.497-32.758 12.497-45.254 0l-77.112-77.111-2.34 1.53c-30.126 19.354-65.812 30.806-104.13 31.427L491 664c-109.905 0-199-89.095-199-199s89.095-199 199-199z m0 64c-74.558 0-135 60.442-135 135 0 74.558 60.442 135 135 135 74.558 0 135-60.442 135-135 0-74.558-60.442-135-135-135z" fill="#999999" p-id="30796"></path></svg>',
                    viewCom: VerifyView,
                    editCom: VerifyEdit,
                    styleList: [
                        {
                            name: '默认样式',
                            value: 'style1'
                        },
                    ],
                    defaultStyle: 'style1',
                    defaultData: {
                        titleFont: {
                            fontFamily: 'Microsoft YaHei',
                            fontSize: '22px',
                            fontWeight: 800,
                            lineHeight: '1.0'
                        },
                        textFont: {
                            fontFamily: 'Microsoft YaHei',
                            fontSize: '10px',
                            fontWeight: 400,
                            lineHeight: '1.2'
                        },
                        showIndex: 0,
                        data: [
                            {
                                title: '官方正品',
                                text: '该产品信息已通过数字化溯源系统认证'
                            },
                            {
                                title: '非官方正品',
                                text: '该产品信息未通过数字化溯源系统认证'
                            }
                        ]
                    }
                },
                product: {
                    text: '产品详情',
                    icon: '<svg t="1776146386025" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="39279" width="40" height="40"><path d="M768 320l-64 0L704 288C704 164.48 603.52 64 480 64 356.48 64 256 164.48 256 288L256 320 192 320C121.6 320 64 377.6 64 448l0 384c0 70.4 57.6 128 128 128l576 0c70.4 0 128-57.6 128-128L896 448C896 377.6 838.4 320 768 320zM320 288C320 199.68 391.68 128 480 128 568.32 128 640 199.68 640 288L640 320 320 320 320 288zM832 832c0 35.2-28.8 64-64 64L192 896c-35.2 0-64-28.8-64-64L128 448c0-35.2 28.8-64 64-64l64 0 0 96C256 497.92 270.08 512 288 512 305.92 512 320 497.92 320 480L320 384l320 0 0 96C640 497.92 654.08 512 672 512 689.92 512 704 497.92 704 480L704 384l64 0c35.2 0 64 28.8 64 64L832 832z" fill="#999999" p-id="39280"></path></svg>',
                    viewCom: ProductView,
                    editCom: ProductEdit,
                    styleList: [
                        {
                            name: '内容居左',
                            value: 'style1'
                        },
                        {
                            name: '内容居右',
                            value: 'style2'
                        },
                    ],
                    defaultStyle: 'style1',
                    defaultData: {
                        titleFont: {
                            fontFamily: 'Microsoft YaHei',
                            fontSize: '16px',
                            fontWeight: 400,
                            color: 'rgba(113, 118, 158, 1)',
                            lineHeight: '1.6'
                        },
                        textFont: {
                            fontFamily: 'Microsoft YaHei',
                            fontSize: '16px',
                            fontWeight: 400,
                            color: 'rgba(58, 60, 80, 1)',
                            lineHeight: '1.6'
                        },
                        imageWidth: 50,
                        data: [
                            { name: '产品图片:', display: true, key: 'productPic' },
                            { name: '产品名称:', display: true, key: 'product_name' },
                            { name: '产品编码:', display: true, key: 'product_code' },
                            { name: '生产时间:', display: true, key: 'productTime' },
                            { name: '有效期:', display: true, key: 'periodDate' },
                            { name: '批次号:', display: true, key: 'batchNo' },
                            { name: '首次扫码时间:', display: true, key: 'create_time' },
                            { name: '扫码次数:', display: true, key: 'count' },
                            { name: '追溯码:', display: true, key: 'qrcode' },
                            { name: '追溯箱码:', display: true, key: 'qrcodeParent' },
                            { name: '规格:', display: true, key: 'specs' },
                            { name: '出库时间:', display: true, key: 'outBillTime' },
                            { name: '生产工厂:', display: true, key: 'enterpriseName' },
                            { name: '经销商:', display: true, key: 'dealerName' }
                        ]
                    }
                },
                spacing: {
                    text: '上下间距',
                    icon: '<svg t="1776146420952" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="41346" width="40" height="40"><path d="M174.6944 153.6h674.6112c11.6736 0 21.0944 11.4688 21.0944 25.6s-9.4208 25.6-21.0944 25.6H174.6944C163.0208 204.8 153.6 193.3312 153.6 179.2s9.4208-25.6 21.0944-25.6zM174.6944 819.2h674.6112c11.6736 0 21.0944 11.4688 21.0944 25.6s-9.4208 25.6-21.0944 25.6H174.6944C163.0208 870.4 153.6 858.9312 153.6 844.8s9.4208-25.6 21.0944-25.6zM526.7456 261.0176l132.7616 108.5952c8.1408 6.656 8.1408 17.4592 0 24.1152a24.2688 24.2688 0 0 1-29.4912 0l-97.1776-79.4624v395.4688l97.1776-79.4624a23.3984 23.3984 0 0 1 14.7456-5.0176c5.5296 0 10.8032 1.792 14.7456 5.0176 8.1408 6.656 8.1408 17.408 0 24.1152l-132.7616 108.5952A23.3984 23.3984 0 0 1 512 768a23.3984 23.3984 0 0 1-14.7456-5.0176l-132.7616-108.544a14.9504 14.9504 0 0 1 0-24.1664 23.3984 23.3984 0 0 1 14.7456-5.0176c5.5296 0 10.8544 1.792 14.7456 5.0176l97.1776 79.4624V314.2656L393.984 393.728a24.2688 24.2688 0 0 1-29.4912 0 14.9504 14.9504 0 0 1 0-24.1152l132.7616-108.5952a24.4224 24.4224 0 0 1 29.4912 0z" p-id="41347" fill="#999999"></path></svg>',
                    viewCom: SpacingView,
                    editCom: SpacingEdit,
                    styleList: [
                        {
                            name: '默认布局',
                            value: 'style1'
                        }
                    ],
                    defaultStyle: 'style1',
                    defaultData: {
                        height: 20,
                    }
                },
                divider: {
                    text: '分隔线',
                    icon: '<svg t="1776411956356" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4493" width="40" height="40"><path d="M798.34 153.2v212.65c0 21.46-20.88 39.94-47.79 39.94H272.69c-26.91 0-47.79-18.48-47.79-39.94V155.89c0-11.31-9.17-20.48-20.48-20.48s-20.48 9.17-20.48 20.48v209.96c0 45.27 40.25 80.9 88.75 80.9h477.87c48.49 0 88.75-35.62 88.75-80.9V153.2c0-11.31-9.17-20.48-20.48-20.48-11.32 0-20.49 9.17-20.49 20.48z m0 716.8V657.35c0-21.46-20.88-39.93-47.79-39.93H272.69c-26.91 0-47.79 18.47-47.79 39.93v209.96c0 11.31-9.17 20.48-20.48 20.48s-20.48-9.17-20.48-20.48V657.35c0-45.27 40.25-80.9 88.75-80.9h477.87c48.49 0 88.75 35.62 88.75 80.9V870c0 11.31-9.17 20.48-20.48 20.48-11.32 0-20.49-9.17-20.49-20.48z m0 0" p-id="4494" fill="#999999"></path><path d="M221.49 532.08h580.27c11.31 0 20.48-9.17 20.48-20.48s-9.17-20.48-20.48-20.48H221.49c-11.31 0-20.48 9.17-20.48 20.48s9.16 20.48 20.48 20.48z m0 0" p-id="4495" fill="#999999"></path></svg>',
                    viewCom: DividerView,
                    editCom: DividerEdit,
                    styleList: [
                        {
                            name: '默认样式',
                            value: 'style1'
                        },
                    ],
                    defaultStyle: 'style1',
                    defaultData: {
                        color: 'rgba(220, 220, 220, 0.5)',
                        lineWidth: 2,
                    }
                }
            },
            skipValidationTypes: ['page', 'spacing', 'divider'],  // 提交时不需要校验数据的组件类型
            viewConfigs: [],        // 页面组件配置 
            newType: '',        // 新增组件类型
            newIndex: null,      // 新增组件索引
            isEnter: false,      // 新增组件是否进入目标区域
            curIndex: null,     // 当前组件的索引
            curConfig: null,      // 当前组件的配置 
        }
    },
    watch: {
        '$route'(to, from) {
            this.loadData();
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        async loadData() {
            this.templateId = this.$route.query.templateId || 0
            this.loading = true
            const res = await customPage({ templateId: this.templateId })
            this.loading = false
            if (res.data && res.data.length) {
                this.viewConfigs = res.data.map(item => ({
                    type: item.component,
                    text: item.text,
                    styleList: this.typeList[item.component]['styleList'],
                    style: item.style,
                    data: JSON.parse(item.setStyle),
                }));
            } else {
                var type = 'page'
                this.viewConfigs = [{
                    type: type,
                    text: this.typeList[type]['text'],
                    styleList: this.typeList[type]['styleList'],
                    style: this.typeList[type]['defaultStyle'],
                    data: this.typeList[type]['defaultData'],
                }]
            }
            this.selectItem(0);
        },
        // 选择组件
        selectItem(index) {
            if (index >= this.viewConfigs.length) {
                return
            }
            this.curIndex = index
            this.curConfig = this.viewConfigs[index]
        },
        // 删除组件
        deleteItem(e, index) {
            this.viewConfigs.splice(index, 1)
            this.curIndex = null
            this.curConfig = null
        },
        // 添加组件到视图-拖拽开始  
        dragStart(e) {
            this.newType = e.target.dataset.type
            this.isEnter = false
        },
        // 添加组件到视图-拖拽结束  
        dragEnd(e) {
            this.newType = ''
            this.isEnter = false
            if (this.newIndex) {
                if (this.viewConfigs[this.newIndex] && this.viewConfigs[this.newIndex].status == 2) {
                    this.$delete(this.viewConfigs[this.newIndex], 'status')
                }
                this.selectItem(this.newIndex)
            }
        },
        // 移动中
        dragOver(e) {
            if (!this.newType) {
                return
            }
            e.preventDefault()
            e.stopPropagation()

            // 首次进入目标区域，先新增组件配置
            if (!this.isEnter) {
                // 先添加到末尾
                this.viewConfigs.push({
                    type: this.newType,    // 组件类型
                    text: this.typeList[this.newType]['text'], // 组件名称
                    styleList: this.typeList[this.newType]['styleList'],
                    style: this.typeList[this.newType]['defaultStyle'],
                    data: this.typeList[this.newType]['defaultData'],
                    status: 2,          // 默认状态
                })
                this.isEnter = true
                this.newIndex = this.viewConfigs.length - 1
            }

            // 然后根据拖拽位置变更配置的顺序
            const target = e.target && e.target.closest ? e.target.closest('.item') : null
            if (target) {
                const rect = target.getBoundingClientRect()
                let [y, h, curIndex] = [e.clientY - rect.top, target.offsetHeight, target.dataset.index]
                let direction = y < (h / 2)

                if (direction) {
                    var i = curIndex == 0 ? 0 : curIndex - 1
                    var result = this.viewConfigs[i]['status'] == 2
                } else {
                    var i = +curIndex + 1
                    var result = this.viewConfigs.length > i && this.viewConfigs[i]['status'] == 2
                }

                if (result) {
                    return
                }
                // 从原位置移除
                const temp = this.viewConfigs.splice(this.newIndex, 1)
                // 插入到新位置
                this.viewConfigs.splice(curIndex, 0, temp[0])
                // 更新当前索引
                this.newIndex = curIndex
            }
        },
        async submit() {
            const form = JSON.parse(JSON.stringify(this.viewConfigs))
            if (form.length == 0) {
                this.$message.error('请添加组件！')
                return
            }

            let params = [];
            for (let i = 0; i < form.length; i++) {
                if (!this.skipValidationTypes.includes(form[i].type) && (!form[i].data || !form[i].data.data || !form[i].data.data.length)) {
                    this.$message.error(`请填写第${i + 1}个组件的完整信息！`)
                    return
                }
                params.push({
                    component: form[i].type,
                    text: form[i].text,
                    style: form[i].style,
                    setStyle: JSON.stringify(form[i].data),
                    sort: i,
                    templateId: this.templateId,
                })
            }

            this.loading = true
            var res = await customPagesave(params)
            this.loading = false
            if (res.status_code == 200) {
                this.$message.success("提交成功!");
                this.$store.dispatch('tagsView/delView', this.$route)
                this.$router.push('/dragpagetemplate')
            } else {
                this.$message.error(res.msg || '提交失败！')
            }
        },
    },
}
</script>


<style lang="scss" scoped>
.decoration-edit {
    display: flex;
    justify-content: space-between;
    padding: 0;
    background: #f7f8f9;
    height: calc(100vh - 84px);
    position: relative;
    overflow-y: hidden;

    .selected {
        border: 2px dashed #409eff;
    }

    .l,
    .r {
        min-width: 340px;
        max-width: 340px;
        height: 100%;
        background: #fff;
    }

    .l {
        padding: 15px;

        ul {
            margin: 0;
            padding: 0;

            li {
                width: 80px;
                height: 80px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                cursor: default;
                list-style: none;
                font-size: 14px;
                color: #666;
                float: left;
                margin: 0 10px;
                border-radius: 6px;
                transition: all .3s;
                cursor: pointer;

                &:hover {
                    background: #efefef;
                }

                svg {
                    display: block;
                    font-size: 40px;
                    margin-bottom: 8px;
                    color: #999;
                }

                p {
                    display: block;
                    margin: 0;
                    font-size: 12px;
                }
            }
        }
    }

    .c {
        padding-top: 20px;
        width: 100%;
        position: relative;
        overflow-y: auto;

        .mobile-device {
            margin: 0 auto;
            width: 100%;
            max-width: 340px;
            aspect-ratio: 9/19;
            border-radius: 40px;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
            position: relative;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
            border: 8px solid #333;
            transition: transform 0.5s ease;
        }

        .top-nav {
            padding: 12px 12px 0 12px;
            top: 0;
            background: #fff;
            z-index: 999;
            transition: all .3s;

            & * {
                pointer-events: none;
            }

            &:hover {
                transform: scale(0.95);
                overflow: hidden;
                box-shadow: 0 0 10px #afafaf;
            }

            .tit {
                position: absolute;
                left: 50%;
                top: 37px;
                transform: translateX(-50%);
            }

            img {
                max-width: 100%;
                image-rendering: -moz-crisp-edges;
                image-rendering: -o-crisp-edges;
                image-rendering: -webkit-optimize-contrast;
                image-rendering: crisp-edges;
                -ms-interpolation-mode: nearest-neighbor;
            }
        }

        ::v-deep .page-container {
            box-sizing: border-box;
            box-shadow: 0 2px 6px #ccc;

            .item {
                transition: all .3s;
                position: relative;

                &:hover {
                    transform: scale(0.95);
                    box-shadow: 0 0 10px #afafaf;

                    .el-icon-error {
                        display: block;
                    }
                }

                div {
                    pointer-events: none;
                }

                .wait {
                    background: #deedff;
                    height: 35px;
                    text-align: center;
                    line-height: 35px;
                    font-size: 12px;
                    color: #666;
                }

                .el-icon-error {
                    position: absolute;
                    right: -10px;
                    top: -6px;
                    color: red;
                    font-size: 25px;
                    cursor: pointer;
                    display: none;
                    z-index: 9999;
                }
            }
        }

        .submit-btn {
            margin-top: 32px;
            text-align: center;

            .el-button {
                width: 120px;
            }
        }
    }
}
</style>